import React from 'react';

const StarIcon = ({ className, type = 'full' }) => {
  if (type === 'half') {
    return (
      <svg
        className={className}
        viewBox="0 0 7 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_417_1532)">
          <path
            d="M0.71 5.75998L0 4.53998L3.14 2.88998L6.13 0.97998L6.84 2.20998L3.71 3.86998L0.71 5.75998Z"
            fill="#222222"
          />
          <path
            d="M3.99996 3.5L4 3L3.99989 2.20998L6.12996 0.97998L6.83996 2.20998L3.70996 3.86998L3.99996 3.5Z"
            fill="#BFBFBF"
          />
          <path
            d="M6.84 4.53998L6.13 5.76998L3.14 3.84998L0 2.19998L0.71 0.97998L3.71 2.86998L6.84 4.53998Z"
            fill="#222222"
          />
          <path
            d="M6.84003 4.54012L6.13003 5.77012L4 4.5L4.00014 3.02508L3.71003 2.87012L6.84003 4.54012Z"
            fill="#BFBFBF"
          />
          <path
            d="M4.10994 6.75H2.68994L2.83994 3.37L2.68994 0H4.10994L3.97994 3.37L4.10994 6.75Z"
            fill="#222222"
          />
        </g>
        <defs>
          <clipPath id="clip0_417_1532">
            <rect width="6.84" height="6.75" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  } else
    return (
      <svg
        id="Lager_1"
        data-name="Lager 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 6.84 6.75"
        fill="#222222"
        className={className}
      >
        <polygon
          className="cls-1"
          points="4.11 6.75 2.69 6.75 2.84 3.37 2.69 0 4.11 0 3.98 3.37 4.11 6.75"
        />
        <polygon
          className="cls-1"
          points="0.71 5.76 0 4.54 3.14 2.89 6.13 0.98 6.84 2.21 3.71 3.87 0.71 5.76"
        />
        <polygon
          className="cls-1"
          points="6.84 4.54 6.13 5.77 3.14 3.85 0 2.2 0.71 0.98 3.71 2.87 6.84 4.54"
        />
      </svg>
    );
};

export default StarIcon;
